import React from 'react';
import { logDeprecation } from '../../../util/logging';
// eslint-disable-next-line zillow/import/no-named-default
import { default as FaceHappyOutline, FaceHappyOutlineSVG } from './IconFaceHappyOutline';
export var SmileyFaceOutlineSVG = FaceHappyOutlineSVG;
var SmileyFaceOutline = function SmileyFaceOutline(props) {
  logDeprecation("`IconSmileyFaceOutline` has been deprecated, use `IconFaceHappyOutline`");
  return /*#__PURE__*/React.createElement(FaceHappyOutline, props);
};
SmileyFaceOutline.displayName = 'IconSmileyFaceOutline';
export default SmileyFaceOutline;